export type EntryDecision =
  | { type: 'render' }
  | { type: 'navigate'; target: string; queryParams?: Record<string, string> }
  | { type: 'external-redirect'; target: string }
  | { type: 'error'; error: Error };

export const RENDER: EntryDecision = { type: 'render' };
